<!-- Show header ONLY if not on login route -->
<app-header *ngIf="!isLoginPage"></app-header>

<!-- Layout for all pages EXCEPT login -->
<div class="app-layout" *ngIf="!isLoginPage">
    <app-sidebar></app-sidebar>

    <div class="main-content">
        <genai-dialog></genai-dialog>
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Layout for login page (no header, no sidebar) -->
<div *ngIf="isLoginPage">
    <genai-dialog></genai-dialog>
    <router-outlet></router-outlet>
</div>